import React from 'react';
import './DonationPage.css';
import MyFooter from './MyFooter';

const DonationPage = () => {
  // Replace these with your actual details
  const donationInfo = {
    upiId: '57069410461@sbi',
    qrCodeImage: '/qrcode.jpg', // or import it
    bankAccount: {
      name: 'Pain & Palliative Care Clini, Manjeri',
      number: '57069410461',
      ifsc: 'SBIN0070197',
      bank: 'State Bank of India',
      branch: 'Manjeri'
    },
    taxBenefits: 'Donations are eligible for tax exemption under Section 80G',
    contactEmail: 'manjeripalliative@gmail.com'
  };

  return (
    <>
    {/* Banner Section */}
    <div className="vm-banner">
    <img 
      src="/donation-banner.jpg" 
      alt="Our Vision and Mission" 
      className="banner-img"
    />
    </div>
    
    <div data-aos="zoom-out" className="donation-page">
      <div className="donation-header">
        <h1>Support Our Cause</h1>
        <p>Your contribution helps us continue our work.</p>
      </div>

      <div className="donation-methods">
        {/* UPI Payment Section */}
        <div className="payment-method">
          <h2>UPI Payment</h2>
          <div className="upi-container">
            <div className="qr-code">
              <img src={donationInfo.qrCodeImage} alt="UPI QR Code" />
            </div>
            <div className="upi-details">
              <p>Scan the QR code with any UPI app</p>
              <div className="upi-id">
                <span>UPI ID:</span>
                <strong>{donationInfo.upiId}</strong>
                <button 
                  onClick={() => navigator.clipboard.writeText(donationInfo.upiId)}
                  className="copy-btn"
                >
                  Copy
                </button>
              </div>
              <p className="note">After payment, please whatsapp or email receipt to {donationInfo.contactEmail}</p>
            </div>
          </div>
        </div>

        {/* Bank Transfer Section */}
        <div className="payment-method">
          <h2>Bank Transfer</h2>
          <div className="bank-details">
            <div className="detail-row">
              <span>Account Name:</span>
              <span>{donationInfo.bankAccount.name}</span>
            </div>
            <div className="detail-row">
              <span>Account Number:</span>
              <span>{donationInfo.bankAccount.number}</span>
            </div>
            <div className="detail-row">
              <span>Bank Name:</span>
              <span>{donationInfo.bankAccount.bank}</span>
            </div>
            <div className="detail-row">
              <span>Branch:</span>
              <span>{donationInfo.bankAccount.branch}</span>
            </div>
            <div className="detail-row">
              <span>IFSC Code:</span>
              <span>{donationInfo.bankAccount.ifsc}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Additional Information */}
      <div className="additional-info">
        <h3>Tax Benefits</h3>
        <p>{donationInfo.taxBenefits}</p>
        
        <h3>Need Help?</h3>
        <p>Email us at <a href={`mailto:${donationInfo.contactEmail}`}>{donationInfo.contactEmail}</a></p>
      </div>
    </div>
    
    </>
  );
};

export default DonationPage;